import { render } from "./empty.vue?vue&type=template&id=af9ca070&ts=true"
import script from "./empty.vue?vue&type=script&lang=tsx"
export * from "./empty.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__